import React from 'react';

const LinkFacebookAccountSvg = (props) => (
    <svg
        width="197"
        height="116"
        viewBox="0 0 197 116"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g filter="url(#filter0_dd)">
            <circle cx="57.7976" cy="56.7976" r="33.7976" fill="#F05537" />
        </g>
        <g filter="url(#filter1_dd)">
            <circle cx="139.203" cy="56.7976" r="33.7976" fill="#1877F2" />
        </g>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M154.706 57.1599C154.706 48.797 147.927 42.0176 139.564 42.0176C131.201 42.0176 124.422 48.797 124.422 57.1599C124.422 64.7178 129.959 70.9822 137.198 72.1182V61.5369H133.353V57.1599H137.198V53.8238C137.198 50.0288 139.459 47.9325 142.918 47.9325C144.574 47.9325 146.307 48.2283 146.307 48.2283V51.9547H144.398C142.517 51.9547 141.93 53.1219 141.93 54.3194V57.1599H146.13L145.458 61.5369H141.93V72.1182C149.169 70.9822 154.706 64.7178 154.706 57.1599Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M145.458 61.5369L146.13 57.1598H141.93V54.3194C141.93 53.1219 142.517 51.9547 144.398 51.9547H146.307V48.2282C146.307 48.2282 144.574 47.9325 142.918 47.9325C139.459 47.9325 137.198 50.0288 137.198 53.8238V57.1598H133.354V61.5369H137.198V72.1181C137.969 72.2391 138.759 72.3021 139.564 72.3021C140.369 72.3021 141.159 72.2391 141.93 72.1181V61.5369H145.458Z"
            fill="#1877F2"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M56.3067 49.117C59.6808 48.3374 63.0498 49.7478 64.9248 52.4195L50.0103 55.8608C50.5226 52.639 52.9327 49.8966 56.3067 49.117V49.117ZM65.0081 61.7821C63.88 63.4523 62.1413 64.7163 60.0214 65.2032C56.6247 65.9879 53.2355 64.5523 51.368 61.8503L66.3304 58.3964L68.7657 57.8338L73.4243 56.759C73.3965 55.7574 73.2704 54.7406 73.0357 53.7289C71.1404 45.5168 62.9438 40.3953 54.7295 42.2925C46.5177 44.1872 41.3948 52.3817 43.2925 60.5938C45.1877 68.806 53.3844 73.925 61.5987 72.0303C66.439 70.9126 70.2017 67.6076 72.0918 63.4044L65.0081 61.7821Z"
            fill="white"
        />
        <g filter="url(#filter2_dd)">
            <ellipse
                cx="98.4995"
                cy="57.8878"
                rx="19.9878"
                ry="20.3512"
                fill="white"
            />
        </g>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M93.0488 60.0683V55.7073V54.2537H94.5025H98.1366V55.7073H94.5025V60.0683H98.1366V61.522H93.0488V60.7951V60.0683ZM101.044 57.161H96.683V58.6146H101.044V57.161ZM99.5903 54.2537H103.224H104.678V55.7073V60.0683V60.7951V61.522H99.5903V60.0683H103.224V55.7073H99.5903V54.2537Z"
            fill="#4B4D63"
        />
        <defs>
            <filter
                id="filter0_dd"
                x="0"
                y="0"
                width="115.595"
                height="115.595"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="4" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.156863 0 0 0 0 0.172549 0 0 0 0 0.207843 0 0 0 0.1 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="1" />
                <feGaussianBlur stdDeviation="12" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.156863 0 0 0 0 0.172549 0 0 0 0 0.207843 0 0 0 0.1 0"
                />
                <feBlend
                    mode="normal"
                    in2="effect1_dropShadow"
                    result="effect2_dropShadow"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect2_dropShadow"
                    result="shape"
                />
            </filter>
            <filter
                id="filter1_dd"
                x="81.4053"
                y="0"
                width="115.595"
                height="115.595"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="4" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.156863 0 0 0 0 0.172549 0 0 0 0 0.207843 0 0 0 0.1 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="1" />
                <feGaussianBlur stdDeviation="12" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.156863 0 0 0 0 0.172549 0 0 0 0 0.207843 0 0 0 0.1 0"
                />
                <feBlend
                    mode="normal"
                    in2="effect1_dropShadow"
                    result="effect2_dropShadow"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect2_dropShadow"
                    result="shape"
                />
            </filter>
            <filter
                id="filter2_dd"
                x="54.5117"
                y="14.5366"
                width="87.9756"
                height="88.7024"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="4" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.156863 0 0 0 0 0.172549 0 0 0 0 0.207843 0 0 0 0.1 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="1" />
                <feGaussianBlur stdDeviation="12" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.156863 0 0 0 0 0.172549 0 0 0 0 0.207843 0 0 0 0.1 0"
                />
                <feBlend
                    mode="normal"
                    in2="effect1_dropShadow"
                    result="effect2_dropShadow"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect2_dropShadow"
                    result="shape"
                />
            </filter>
        </defs>
    </svg>
);

LinkFacebookAccountSvg.displayName = 'LinkFacebookAccountSvg';
export default LinkFacebookAccountSvg;
